import { Router } from './Router';
import { BrowserRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { Toaster } from './components/ui/toaster';
import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ErrorBoundary from './ErrorBoundary';
import SmartlookSH from './components/Smartlook';
import { ApolloProvider } from '@apollo/client';
import { client } from './services/lib/apollo-client';
import OnboardingChecker from './pages/on-boarding/checker';
import { isDevEnvironment } from './hooks/isDevelopment';

function App() {
  const queryClient = new QueryClient();

  useEffect(() => {
    if (isDevEnvironment) {
      console.warn('Google Tag Manager has been disabled because this is a development environment.');
      return;
    }

    if (!import.meta.env.VITE_GTM_ID) {
      return;
    }

    const tagManagerArgs = {
      gtmId: import.meta.env.VITE_GTM_ID,
    };

    TagManager.initialize(tagManagerArgs);
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ApolloProvider client={client}>
          <QueryClientProvider client={queryClient}>
            <Router />
            <SmartlookSH />
            <Toaster />
            <OnboardingChecker />
          </QueryClientProvider>
        </ApolloProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
